export enum GoogleAnalyticsDashboardTypes {
    Audience,
    Device,
    ActiveUsers
}
